//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import {
  BodyPrimaryHarmonyAIIcon,
  PrimaryHarmonyAIIcon,
} from '@components/harmonyai/HarmonyAIIcon';

interface Props {
  shouldUsePrimaryColor: boolean;
}

export const HashtagDropdownTitleLabel = ({ shouldUsePrimaryColor }: Props) => {
  return (
    <Wrapper $shouldUsePrimaryColor={shouldUsePrimaryColor}>
      {shouldUsePrimaryColor ? (
        <PrimaryHarmonyAIIcon />
      ) : (
        <BodyPrimaryHarmonyAIIcon />
      )}
      Recommended
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $shouldUsePrimaryColor: boolean }>(
  ({ $shouldUsePrimaryColor, theme }) => css`
    && {
      display: inline-flex;
    }
    ${$shouldUsePrimaryColor && `color: ${theme.colors.aliases.primary};`}

    align-items: center;
    gap: ${theme.spacings[1]};
  `,
);
